import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-368f1497"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widthRole2" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner widthRole2\" data-v-368f1497><div class=\"widthRole bannerInfo\" data-v-368f1497><img class=\"bannerTxt\" src=\"https://caa-upload.cacpaper.com/nivdf2023/nTxt23.png\" data-v-368f1497></div></div><div class=\"contentItem widthRole\" style=\"margin-top:0px;\" data-v-368f1497><div class=\"ttlIcon\" data-v-368f1497><span data-v-368f1497>论坛背景</span></div><div class=\"tab2P\" data-v-368f1497> 中国智能车大会暨国家智能车发展论坛 (National Intelligent Vehicle Development Forum)是国家自然科学基金委员会信息科学部和中国自动化学会于2015年创办的品牌学术活动，旨在推动我国人工智能基础研究领域重要里程碑计划——国家自然科学基金委员会重大研究计划“视听觉信息的认知计算”，有力促进了我国智能车基础理论研究、成果原始创新和高技术开发，增强我国智能车自主研发技术水平和实际应用能力，促进智能车技术产业化应用，推动其在能源、交通等领域的深入应用和产业转型升级。 </div><div class=\"tab2P\" data-v-368f1497> 2023中国智能车大会暨国家智能车发展论坛将为促进智能车基础理论研究、成果原始创新和高技术开发提供开放互融的交流平台，增强我国智能车自主研发技术水平和实际应用能力，促进智能车技术产业化应用，推动其在能源、交通等领域的深入应用和产业转型升级。 </div></div>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentItem widthRole" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ttlIcon" }, [
    /*#__PURE__*/_createElementVNode("span", null, "论坛安排")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("table", {
      border: "1",
      cellspacing: "0"
    }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "会议时间"),
        /*#__PURE__*/_createElementVNode("td", null, "2023年7月1日到3日")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "会议地点"),
        /*#__PURE__*/_createElementVNode("td", null, "广州南沙·南沙湾滨海会议中心")
      ])
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"contentItem widthRole\" data-v-368f1497><div class=\"ttlIcon\" data-v-368f1497><span data-v-368f1497>组织机构</span></div><div class=\"fileItem\" data-v-368f1497><div class=\"art\" data-v-368f1497><h1 data-v-368f1497> 主办单位： </h1><div data-v-368f1497> 国家自然科学基金委信息科学部<br data-v-368f1497> 中国自动化学会<br data-v-368f1497></div><h1 data-v-368f1497> 承办单位： </h1><div data-v-368f1497> 广州南沙经济技术开发区管理委员会<br data-v-368f1497> 香港科技大学（广州）<br data-v-368f1497> 西安交通大学<br data-v-368f1497></div><h1 data-v-368f1497> 协办单位： </h1><div data-v-368f1497> 中国自动化学会网联智能系统专业委员会<br data-v-368f1497> 中国自动化学会智能车工作委员会<br data-v-368f1497> 中国自动化学会车辆控制与智能化专业委员会<br data-v-368f1497> 中国自动化学会集成自动化技术专业委员会<br data-v-368f1497> 广东省汽车智能网联发展促进会 </div></div></div></div>", 1)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentItem widthRole" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ttlIcon" }, [
    /*#__PURE__*/_createElementVNode("span", null, "日程安排")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("table", {
      border: "1",
      cellspacing: "0"
    }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "日期"),
        /*#__PURE__*/_createElementVNode("td", null, "时间"),
        /*#__PURE__*/_createElementVNode("td", null, "内容")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "7月1日"),
        /*#__PURE__*/_createElementVNode("td", null, "10:00-20:00 "),
        /*#__PURE__*/_createElementVNode("td", null, "签到注册")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { rowspan: "5" }, "7月2日"),
        /*#__PURE__*/_createElementVNode("td", null, "09:00-09:20"),
        /*#__PURE__*/_createElementVNode("td", null, "开幕式")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "09:20-12:00"),
        /*#__PURE__*/_createElementVNode("td", null, "主旨报告")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "14:00-16:30"),
        /*#__PURE__*/_createElementVNode("td", null, "主旨报告")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "15:25-17:00"),
        /*#__PURE__*/_createElementVNode("td", null, "高峰对话")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "18:30-20:30"),
        /*#__PURE__*/_createElementVNode("td", null, "2023 中国自动化学会科学技术奖励大会")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "7月3日"),
        /*#__PURE__*/_createElementVNode("td", null, "09:00-12:00"),
        /*#__PURE__*/_createElementVNode("td", null, "专题论坛")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "14:00-17:00"),
        /*#__PURE__*/_createElementVNode("td", null, "专题论坛")
      ])
    ])
  ])
], -1))
const _hoisted_7 = [
  _hoisted_2,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

import { onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

onMounted(() => {
    setTimeout(function(){
    let imgclassname=document.getElementsByClassName('bannerTxt')
    imgclassname[0] && imgclassname[0].classList.add('bannerTxtHover')

  }, 500)
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
}
}

})